<template>
  <div class="columns is-multiline">
    <div v-if="secteurWarning" class="column is-12">
      <qd-message type="is-warning">
        {{secteurWarning}}
      </qd-message>
    </div>
    <div class="column is-12">
      <div class="card">
        <header class="header-card">
          <p>
            {{ $t('detailProduitReseau.onglet.product')}}
          </p>
        </header>
        <div class="card-content">
          <div class="columns is-marginless is-paddingless is-multiline">
            <figure class="column is-2">
              <app-logo readOnly class="is-pulled-left"
                :elementId="produit.id"
                :libelleElement="libellelogo">
              </app-logo>
            </figure>
            <div class="column is-6">
              <div class="columns">
                <div class="column is-6">
                  <p class="has-text-default is-italic is-size-7">
                    {{ $t('catalogue.number', {
                        reference: produit.reference,
                    })}}
                  </p>
                  <p class="is-size-4 has-text-weight-semibold">{{produit.libelle}}</p>
                  <p class="has-text-default is-italic is-size-7">
                    {{ produit.tiers ? produit.tiers.nomCommercial : null }}
                  </p>
                </div>
              </div>
              <br>
              <b-field class="columns">
                <div class="column is-4">
                  <p class="has-text-default is-italic">
                    {{ $t('detailProduitReseau.format')}}
                  </p>
                  <p class="has-text-weight-semibold">
                    {{ findFormat }}
                  </p>
                </div>
                <div class="column is-4">
                  <p class="has-text-default is-italic">
                    {{ $t('detailProduitReseau.city')}}
                  </p>
                  <p class="has-text-weight-semibold">
                    {{ produit.produitReseau.adresse.ville }}
                  </p>
                </div>
                <div class="column is-4">
                  <p class="has-text-default is-italic">
                    {{ $t('detailProduitReseau.type')}}
                  </p>
                  <p class="has-text-weight-semibold">
                    {{ findType }}
                  </p>
                </div>
              </b-field>
              <b-field class="columns">
                <div class="column is-4">
                  <p class="has-text-default is-italic">
                    {{ $t('detailProduitReseau.dateDebut')}}
                  </p>
                  <p class="has-text-weight-semibold">
                    {{ produit.produitReseau.dateDebut | formatDate }}
                  </p>
                </div>
                <div class="column is-4">
                  <p class="has-text-default is-italic">
                    {{ $t('detailProduitReseau.dateFin')}}
                  </p>
                  <p class="has-text-weight-semibold">
                    {{ produit.produitReseau.dateFin | formatDate }}
                  </p>
                </div>
                <div class="column is-4">
                  <p class="has-text-default is-italic">
                    {{ $t('detailProduitReseau.facesDispo', {
                    date: getDate(dateVisualisation)})}}
                  </p>
                  <p class="has-text-weight-semibold">
                    {{ faceDispo }}
                  </p>
                </div>
              </b-field>
              <b-field class="columns">
                <div class="column is-4"
                  v-if="showLogisticable">
                  <p class="has-text-default is-italic">
                    {{ $t('detailProduitReseau.logisticable')}}
                  </p>
                  <p class="has-text-weight-semibold">
                    {{ !produit.logisticable ? $t('general.non') : $t('general.oui') }}
                  </p>
                </div>
                <div class="column is-4"
                     v-if="produit.supportCommercial.categorieVente
                     === constantes.CATEGORIE_REGROUPEMENT">
                  <p class="has-text-default is-italic">
                    {{ $t('detailProduitReseau.partageable')}}
                  </p>
                  <p class="has-text-weight-semibold">
                    {{ produit.produitReseau.partageable ? $t('general.oui')
                    : $t('general.non')}}
                  </p>
                </div>
                <div class="column is-4"
                     v-if="produit.supportCommercial.categorieVente
                     === constantes.CATEGORIE_REGROUPEMENT_LC">
                  <p class="has-text-default is-italic">
                    {{ $t('detailProduitReseau.quantiteFacePrevue')}}
                  </p>
                  <p class="has-text-weight-semibold">
                    {{ produit.produitReseau.quantiteFaces }}
                  </p>
                </div>
                <div class="column is-4" v-if="produit.supportCommercial.categorieVente
                    === constantes.CATEGORIE_REGROUPEMENT_LC"
                     :class="{ 'is-offset-4': produit.supportCommercial.categorieVente
                    === constantes.CATEGORIE_REGROUPEMENT_LC
                  }">
                  <p class="has-text-default is-italic">
                    {{ $t('detailProduitReseau.tarif')}}
                  </p>
                  <p class="has-text-weight-semibold">
                    {{ getTarif }}
                  </p>
                </div>
                <div class="column is-4" v-else>
                  <p class="has-text-default is-italic">
                    {{ $t('detailProduitReseau.nbFacePrevu')}}
                  </p>
                  <p class="has-text-weight-semibold">
                    {{ dispo }}
                  </p>
                </div>
              </b-field>
              <div class="columns is-multiline">
                <div class="column is-4">
                  <p class="has-text-default is-italic">
                    {{ $t('detailProduitReseau.agence') }}
                  </p>
                  <p class="has-text-weight-bold is-narrow">
                    {{ getAgenceLibelle }}
                  </p>
                </div>
                <div class="column is-4" v-if="societesInformations.length > 1">
                  <p class="has-text-default is-italic">
                    {{ $t('detailProduitReseau.societe') }}
                  </p>
                  <p class="has-text-weight-bold is-narrow">
                    {{ getLibelleSociete }}
                  </p>
                </div>
                <div class="column is-4 is-offset-4" v-if="produit.supportCommercial.categorieVente
                    !== constantes.CATEGORIE_REGROUPEMENT_LC">
                  <p class="has-text-default is-italic">
                    {{ $t('detailProduitReseau.tarif')}}
                  </p>
                  <p class="has-text-weight-semibold">
                    {{ getTarif }}
                  </p>
                </div>
                <div class="column is-4" v-if="showSecteur">
                  <p class="has-text-default is-italic">
                    {{ $t('detailProduitReseau.secteur') }}
                  </p>
                  <p class="has-text-weight-bold is-narrow">
                    {{ secteurLibelle }}
                  </p>
                </div>
                <div class="column is-4" v-if="ligneCommandeARenouvelerSpe">
                  <p class="has-text-default is-italic">
                    {{ $t('detailProduitReseau.renouvelable')}}
                  </p>
                  <p class="has-text-weight-semibold">
                    {{ produit.renouvelable ? $t('general.oui') : $t('general.non') }}
                  </p>
                </div>
              </div>
            </div>
            <gmap-map class="column is-4"
                      @tilesloaded="updateBounds()"
                      ref="map"
              :center="center"
              :zoom="zoomDefault">
                <gmap-marker :key="m.num"
                  v-for="(m) in markers"
                  :position="m.position"
                  :draggable="false"
                  :icon="m.icon">
                </gmap-marker>
              </gmap-map>
          </div>
        </div>
      </div>
    </div>
    <compte-analytique
      :produit="produit"
      column-size="is-6">
    </compte-analytique>
    <produit-commentaire-vente-card
      :produit="produit"
      class="column is-6"
      isDetail/>
    <div class="column is-12">
      <div class="card">
        <header class="header-card">
          <p>
            {{ $t('piecesJointes.attachments')}}
          </p>
        </header>
        <div class="card-content">
          <app-pieces-jointes :checkPermissions="checkPermissions(permsCatalogue.maj)"
                              readOnly deletable autoSave
                              :canAddPj="!produitWithHolding"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import PiecesJointes from '@/components/general/piecesJointes';
import Logo from '@/components/general/Logo';
import markersGetterProduit from '@/services/catalogue/produitReseau/makersGetter';
import centerMapGetter from '@/services/catalogue/produitReseau/centerMapGetter';
import { COULEUR_PUCE_DEFAULT, ZOOM_DEFAULT } from '@/configuration/general/carteConf';
import {
  CATEGORIE_REGROUPEMENT_LC,
  CATEGORIE_REGROUPEMENT, CATEGORIE_REGROUPEMENT_MAIRIE,
} from '@/configuration/catalogue/produitConf';
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import { CATALOGUE } from '@/configuration/permissionsBodacConf';
import updateBounds from '@/services/general/map/updateBounds';
import getLiaisonTarifADate from '@/services/catalogue/getLiaisonTarifADate';
import { formatDevise } from '@/services/general/filters/formatDevise';
import markersGetter from '@/services/general/map/markersGetter';
import compteAnalytique from '@/components/catalogue/produitGeneral/compteAnalytique/c_compteAnalytiqueCard';
import produitCommentaireVenteCard from '@/components/catalogue/produitGeneral/produitCommentaireVenteCard';
import formatDate from '@/services/general/formatDate';
import moment from 'moment';
import { getAllPlanning } from '@/api/dispo';
import { INFINITE_DAY } from '@/configuration/general';
import { siteHasHolding } from '@/services/general/holding';
import MixinParametreInterne from '@/mixins/parametreInterne';

const Parametres = createNamespacedHelpers('parametres');
const permissions = createNamespacedHelpers('permissions');
const User = createNamespacedHelpers('user');
const Societe = createNamespacedHelpers('societe');

export default {
  mixins: [MixinParametreInterne],
  name: 'CatalogueDetailProduitReseauProduit',
  props: {
    produit: Object,
    dateVisualisation: {
      required: true,
    },
  },
  components: {
    appPiecesJointes: PiecesJointes,
    appLogo: Logo,
    compteAnalytique,
    produitCommentaireVenteCard,
  },
  data() {
    return {
      zoomDefault: ZOOM_DEFAULT,
      permsCatalogue: CATALOGUE,
      firstTime: true,
      dispo: 0,
      constantes: {
        CATEGORIE_REGROUPEMENT_LC,
        CATEGORIE_REGROUPEMENT,
        CATEGORIE_REGROUPEMENT_MAIRIE,
      },
    };
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...User.mapGetters({
      user: 'user',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      societesInformations: 'societesInformations',
    }),
    moduleSecteurActive() {
      return this.parametresInterne(typesParametres.PARAMETRES_INTERNE_KEYS.moduleSecteur.key);
    },
    produitWithHolding() {
      return (siteHasHolding() && this.produit
          && this.produit.supportCommercial.societeId !== this.societeActiveId);
    },
    getAgenceLibelle() {
      const agenceFind = this.user.agences.find((agence) => {
        return agence.agenceId === this.produit.agenceId;
      });
      if (agenceFind) return agenceFind.libelleAgence;
      return '';
    },
    typesReseau() {
      return this.parametre(typesParametres.PARAMETRES_KEYS.typeReseau);
    },
    formats() {
      return this.parametre(typesParametres.PARAMETRES_KEYS.format);
    },
    getTarif() {
      if (this.produit.liaisonsTarif && this.produit.produitReseau.produitParDefautId) {
        const produitLocation = getLiaisonTarifADate(
          this.produit,
          this.produit.produitReseau.produitParDefautId,
          new Date(),
        );
        if (produitLocation) return formatDevise(produitLocation.prixUnitaire);
      }
      return this.$t('detailProduitReseau.nonDefini');
    },
    findType() {
      const typeReseau = this.typesReseau.find(
        typeReseau => typeReseau.id === this.produit.produitReseau.typeReseauId,
      );
      return typeReseau ? typeReseau.libelle : null;
    },
    findFormat() {
      const format = this.formats.find(format => format.id === this.produit.produitReseau.formatId);
      return format ? format.libelle : null;
    },
    faceDispo() {
      let nbFaces = 0;
      this.produit.produitReseau.affectationsReseauFace.forEach((affectation) => {
        const dateFin = affectation.dateFin ? moment(affectation.dateFin) : moment(INFINITE_DAY);
        if (!this.dateVisualisation || moment(this.dateVisualisation)
          .isBetween(moment(affectation.dateDebut), dateFin, 'day', [])) {
          nbFaces += 1;
        }
      });
      return nbFaces === 0 ? this.$t('detailProduitReseau.pasFace') : nbFaces;
    },
    markers() {
      const markers = markersGetterProduit(
        this.produit, this.dateVisualisation, this.produit.couleurHtmlRgb,
      );
      if (markers.length === 0) {
        return markersGetter(this.produit.produitReseau.adresse,
          this.produit.couleurHtmlRgb ? this.produit.couleurHtmlRgb : COULEUR_PUCE_DEFAULT);
      }
      return markers;
    },
    center() {
      return centerMapGetter(this.produit.produitReseau, this.markers);
    },
    libellelogo() {
      if (this.produit.supportCommercial.categorieVente
        === this.constantes.CATEGORIE_REGROUPEMENT) return this.$t('detailProduitReseau.libelleProduitTempoForLogo', { ref: this.produit.reference });
      if (this.produit.supportCommercial.categorieVente
        === this.constantes.CATEGORIE_REGROUPEMENT_LC) return this.$t('detailProduitReseau.libelleProduitLcForLogo', { ref: this.produit.reference });
      return this.$t('detailReseauMairie.libelleProduitMairieForLogo', { ref: this.produit.reference });
    },
    getLibelleSociete() {
      const societe = this.societesInformations.find((societe) => {
        return societe.id === this.produit.supportCommercial.societeId;
      });
      if (societe) return societe.libelle;
      return '';
    },
    secteurs() {
      return this.parametre(typesParametres.PARAMETRES_KEYS.secteur);
    },
    secteurLibelle() {
      return this.produit.secteurs.map(ps => {
        return this.secteurs.find(s => s.id === ps.secteurId)?.libelle;
      }).join(', ');
    },
    secteurWarning() {
      if (!this.produit?.secteurs) return null;
      const psecteurs = this.produit.secteurs?.map(ps => {
        return this.secteurs.find(s => s.id === ps.secteurId);
      }).filter(ps => !ps.actif);
      if (psecteurs.length > 0) {
        return this.$t('detailProduitReseau.warnings.secteurs', { secteurs: psecteurs.map(ps => ps.libelle).join(', ') });
      }
      return null;
    },
    showSecteur() {
      return this.moduleSecteurActive
        && this.produit?.supportCommercial?.categorieVente === CATEGORIE_REGROUPEMENT;
    },
    showLogisticable() {
      return [
        CATEGORIE_REGROUPEMENT,
        CATEGORIE_REGROUPEMENT_LC,
      ].includes(this.produit?.supportCommercial?.categorieVente);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
      loadParametresInterne: 'loadParametresInterne',
    }),
    getDate(date) {
      return formatDate(date);
    },
    async updateBounds() {
      if (this.firstTime && (markersGetterProduit(
        this.produit, this.dateVisualisation, this.produit.couleurHtmlRgb,
      )).length > 0) {
        updateBounds(await this.$refs.map);
        this.firstTime = false;
      }
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametres([
        typesParametres.PARAMETRES_KEYS.format,
        typesParametres.PARAMETRES_KEYS.typeReseau,
        typesParametres.PARAMETRES_KEYS.secteur,
      ]);
      await this.loadParametresInterne([typesParametres.PARAMETRES_INTERNE_KEYS.moduleSecteur.key]);
      if (this.dateVisualisation) {
        const dateDebut = moment(this.dateVisualisation).startOf('week').toDate();
        const dateFin = moment(this.dateVisualisation).endOf('week').toDate();
        if (this.produit.supportCommercial.categorieVente
          !== this.constantes.CATEGORIE_REGROUPEMENT_LC && dateDebut && dateFin) {
          this.dispo = (await getAllPlanning([this.produit.id], dateDebut, dateFin)
          ).data.result[this.produit.id][0].stock;
        }
      }
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw (e);
    }
  },
};
</script>

<style scoped>

</style>
